module.exports = __webpack_public_path__ + "static/media/apply-img1.6ec0fdcb.png";